import React, { useState, useEffect, useRef } from 'react';
import styles from './Projects.module.css';

const LazyImage = ({ src, alt = '', className = '', onLoad = null, rootMargin = '100px', placeholder = null }) => {
  const [imageSrc, setImageSrc] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [hasError, setHasError] = useState(false);
  const imgRef = useRef(null);
  const observerRef = useRef(null);

  useEffect(() => {
    if (!src) { setIsLoading(false); return; }
    observerRef.current = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting && !imageSrc) {
          setImageSrc(src);
          if (observerRef.current && imgRef.current) observerRef.current.unobserve(imgRef.current);
        }
      },
      { rootMargin, threshold: 0.01 }
    );
    if (imgRef.current) observerRef.current.observe(imgRef.current);
    return () => { if (observerRef.current) observerRef.current.disconnect(); };
  }, [src, imageSrc, rootMargin]);

  const handleLoad = () => { setIsLoading(false); if (onLoad) onLoad(); };
  const handleError = () => { setIsLoading(false); setHasError(true); };

  return (
    <div ref={imgRef} className={`${styles.lazyImageWrapper} ${className}`} style={{ position: 'relative', overflow: 'hidden' }}>
      {isLoading && !hasError && <div className={styles.imageSkeleton} />}
      {isLoading && placeholder && <div className={styles.placeholderWrapper}>{placeholder}</div>}
      {imageSrc && !hasError && (
        <img src={imageSrc} alt={alt} className={`${styles.lazyImage} ${!isLoading ? styles.loaded : ''}`}
          onLoad={handleLoad} onError={handleError} loading="lazy" />
      )}
      {hasError && (
        <div className={styles.imageError}>
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" style={{ width: '40px', height: '40px', opacity: 0.3 }}>
            <path d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
          </svg>
        </div>
      )}
    </div>
  );
};

export default LazyImage;
